const INFO_SESSION_SURVEY_SLUG = 'infSessionApr8';

function callTracking(windowObject, trackerName, callback) {
  if (!windowObject) {
    return;
  }

  try {
    callback(windowObject);
  } catch (error) {
    console.error(`${trackerName} survey tracking failed`, error);
  }
}

export function runSurveyPostSubmitTracking(slug, windowObject = window) {
  if (slug !== INFO_SESSION_SURVEY_SLUG || !windowObject) {
    return;
  }

  callTracking(windowObject, 'Yandex Metrica', (targetWindow) => {
    if (typeof targetWindow.ym === 'function') {
      targetWindow.ym(99696795, 'reachGoal', 'infosessionsubmitted');
    }
  });

  callTracking(windowObject, 'Meta Pixel', (targetWindow) => {
    if (typeof targetWindow.fbq === 'function') {
      targetWindow.fbq('track', 'Lead');
    }
  });
}
